import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DisplayCourseApplications = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deletingIds, setDeletingIds] = useState([]);

    useEffect(() => {
        fetchApplications();
    }, []);

    const fetchApplications = async () => {
        try {
            setLoading(true);
            const url = API_BASE_URL ? `${API_BASE_URL}/api/trainings` : '/api/trainings';
            const response = await axios.get(url);
            const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
            setApplications(data);
        } catch (err) {
            setError(err.message || 'Failed to fetch applications');
        } finally {
            setLoading(false);
        }
    };

    const deleteApplication = async (app) => {
        const id = app.id ?? app._id;
        if (!id) {
            alert('Unable to delete application: missing ID');
            return;
        }

        const confirmed = window.confirm('Are you sure you want to delete this application?');
        if (!confirmed) return;

        try {
            setDeletingIds((prev) => [...prev, id]);
            const deleteUrl = API_BASE_URL ? `${API_BASE_URL}/api/trainings/${id}` : `/api/trainings/${id}`;
            await axios.delete(deleteUrl);
            setApplications((prev) => prev.filter((item) => (item.id ?? item._id) !== id));
            alert('Application deleted successfully.');
        } catch (err) {
            alert('Failed to delete application: ' + (err.message || 'Unknown error'));
        } finally {
            setDeletingIds((prev) => prev.filter((deleteId) => deleteId !== id));
        }
    };

    return (
        <div className="min-h-screen bg-base-200 py-8">
            <div className="mx-auto max-w-6xl px-4">
                <div className="card bg-base-100 shadow-xl border border-base-200">
                    <div className="card-body space-y-6">
                        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                            <div>
                                <h2 className="text-2xl font-semibold">Training Applications</h2>
                                {/* <p className="text-sm text-base-content/60">All submitted applications from the training form.</p> */}
                            </div>
                            <button
                                className="btn btn-primary"
                                onClick={fetchApplications}
                                disabled={loading}
                            >
                                {loading ? 'Refreshing...' : 'Refresh'}
                            </button>
                        </div>

                        {error && (
                            <div className="alert alert-error shadow-lg">
                                <div>
                                    <span>{error}</span>
                                </div>
                            </div>
                        )}

                        {loading ? (
                            <div className="flex justify-center py-8">
                                <span className="loading loading-lg"></span>
                            </div>
                        ) : applications.length === 0 ? (
                            <div className="alert alert-info shadow-lg">
                                <div>
                                    <span>No applications found.</span>
                                </div>
                            </div>
                        ) : (
                            <div className="overflow-x-auto">
                                <table className="table w-full table-zebra">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Place</th>
                                            <th>Mobile No</th>
                                            <th>Submitted At</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {applications.map((app, index) => {
                                            const id = app.id ?? app._id ?? index;
                                            const isDeleting = deletingIds.includes(id);
                                            return (
                                                <tr key={id}>
                                                    <th>{index + 1}</th>
                                                    <td>{app.name}</td>
                                                    <td>{app.place}</td>
                                                    <td>{app.mobile_no}</td>
                                                    <td>{app.created_at ? new Date(app.created_at).toLocaleString() : '—'}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-error btn-sm"
                                                            onClick={() => deleteApplication(app)}
                                                            disabled={isDeleting}
                                                        >
                                                            {isDeleting ? 'Deleting...' : 'Delete'}
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisplayCourseApplications;